import client from "./api";

// Downloads the server-generated, localized PDF user manual for an app.
// Language defaults to the user's current selection (suite_lang).
export async function downloadManual(appKey, lang) {
  const language = lang || localStorage.getItem("suite_lang") || "ENG";
  const res = await client.get(`/manual/${appKey}.pdf`, {
    params: { lang: language },
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${appKey}_user_manual_${language}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

// Opens the localized manual PDF in a new browser tab for reading.
export async function openManual(appKey, lang) {
  const language = lang || localStorage.getItem("suite_lang") || "ENG";
  const res = await client.get(`/manual/${appKey}.pdf`, {
    params: { lang: language },
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  window.open(url, "_blank", "noopener,noreferrer");
}

// Downloads a "special" manual (cs_frontend | cs_backend | master_enabler_full).
export async function downloadSpecialManual(mid, lang) {
  const language = lang || "ENG";
  const res = await client.get(`/manual/special/${mid}.pdf`, {
    params: { lang: language },
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${mid}_${language}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
